import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 18,
    paddingLeft : 2
  },
  titleContainer: {
    backgroundColor: theme.ModalBGColor
  },
  logoContainer: {
    float: 'right',
    padding: '5px',
    height: '20px'
  },
  title: {
    fontSize: theme.headerTextFontSize,
    fontWeight: 600,
    marginRight: 18
  },
  terminal: {
    marginLeft: 18,
    paddingRight: 18,
    borderRight: `2px solid #000000`
  },
  date: {
    marginLeft: 18
  },
  header: {
    borderBottom: '1px solid #000000'
  }
});

const PrintHeader = ({ classes, driverName, driverNumber, dispatchDate, terminalCode }) => {
  return (
    <div className={`${classes.header}`}>
      <div className={classes.container}>
        <span>
          <span className={classes.title}>Driver Performance</span>
          <span className={classes.terminal}>{terminalCode} </span>
          <span className={classes.date}> {dispatchDate}</span>
          <span className={classes.date}>
            {driverName} ({driverNumber})
          </span>
        </span>
        <img
          src="../../../../../../images/RouteMax_Logo_Print.svg"
          className={classes.logoContainer}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(PrintHeader);
